import React from 'react'; 
import { Button } from 'semantic-ui-react';
import { SearchBar } from 'dyl-components';
import '../index.scss';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Toolbar = ({ search, onSearchSubmit, cancelFunction, onChangeSearch, setIsSoundModalOpen }) => {
    return (
        <div style={{display: 'flex'}}>
            <div style={{flex: 1}}>
                <SearchBar
                    isSearching={false}
                    search={search}
                    searchFcn={onSearchSubmit}
                    cancelFcn={cancelFunction}
                    placeholder='Search by label'
                    addClassNames='PhoneAudio__search'
                    onChange={onChangeSearch}
                    bottomError
                />
            </div>
            <div>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_ADD}>
                    <Button style={{ marginRight: 10 }} className='PhoneAudioToolbar__button' onClick={() => { setIsSoundModalOpen(true) }}>
                        + New
                    </Button>
                </RestrictedView>
            </div>
        </div>

    )
}

export default Toolbar;
